export default __webpack_public_path__ + "static/media/pets.0a12f7b6.jpg";